// extracted by mini-css-extract-plugin
export default {"image":"styles_image__za3rT","content":"styles_content__Sz+sZ","more":"styles_more__zxmMf"};